import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../components/forms/input'
import MyRadio from '../../components/forms/radio'

const EditJobFairVenue = (props) => {
    const { id, name, campus, slot_type } = props.data
    const [formValue, setFormValue] = useState(
        {
            venue_id: id,
            name: name,
            campus: campus,
            slot_type: slot_type
        }
    )
    const [errorMsg, setErrorMsg] = useState({})

    const handleSubmit = () => {
        setErrorMsg({})

        if (!formValue.name) {
            setErrorMsg({ nameEmpty: '双选会展位名称不能为空' })
            return false
        }

        axios.post('/admin/venue/edit', {
            venue_id: formValue.venue_id,
            campus: formValue.campus,
            slot_type: formValue.slot_type,
            name: formValue.name
        })
            .then(function (response) {
                if (response.errcode === 0) {
                    message.success('编辑成功！')
                    props.getVenueData()
                }
            })
            .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
            })
    }

    const handleOk = () => {
        const isOk = handleSubmit()
        if (isOk !== false) { handleCancel() }
    }

    const handleCancel = () => {
        setErrorMsg({})
        setFormValue({})
        props.isCancel()
    }

    return (
        <Modal
            title="编辑双选会展位"
            width='800px'
            open={props.isOpen}
            onCancel={handleCancel}
            maskClosable={false}
            footer={[
                <Button key='cancel' onClick={handleCancel}>取消</Button>,
                <Button key='isOk' type="primary" onClick={handleOk}>保存</Button>
            ]}
        >

            <MyRadio
                id='campus'
                label='所属校区'
                options={[
                    { label: '兰州职业技术学院', value: 1 },
                    { label: '雁儿湾校区', value: 2 },
                    { label: '桃林校区', value: 3 }
                ]}
                value={formValue.campus}
                onChange={setFormValue}
            />

            <MyInput
                id="name"
                required
                autoFocus
                maxLength={64}
                label='展位名称'
                placeholder='请输入双选会展位名称'
                value={formValue.name}
                onChange={setFormValue}
                errorMsg={errorMsg.nameEmpty}
            />

        </Modal>
    )
}

export default EditJobFairVenue